import {EquipmentScoreType} from '../../../../../types/MarketType';
import type {EquipmentFlagItem} from '../types/EquipmentFlagItem';
import {filterByShareRange} from './filterByShareRange';

/**
 * Returns equipment flags for a given share range, in API order:
 * highlighted_features → available_non_highlighted_features → missing_highlighted_features → missing_non_highlighted_features.
 * Each item is mapped to its legend category for correct flag color.
 */
export function getEquipmentFlagsForShareRange(
  equipmentScore: EquipmentScoreType | undefined,
  minShare: number | undefined,
  maxShare: number | undefined
): EquipmentFlagItem[] {
  if (!equipmentScore?.feature_share) {
    return [];
  }

  const fs = equipmentScore.feature_share;
  const highlighted = filterByShareRange(fs.highlighted_features, minShare, maxShare).map(
    (item): EquipmentFlagItem => ({
      feature: item.feature,
      category: 'availableHighlightFeature',
    })
  );
  const nonHighlighted = filterByShareRange(
    fs.available_non_highlighted_features,
    minShare,
    maxShare
  ).map(
    (item): EquipmentFlagItem => ({
      feature: item.feature,
      category: 'availableFeature',
    })
  );
  const missingHighlighted = filterByShareRange(
    fs.missing_highlighted_features,
    minShare,
    maxShare
  ).map(
    (item): EquipmentFlagItem => ({
      feature: item.feature,
      category: 'missingHighlightFeature',
    })
  );
  const missingNonHighlighted = filterByShareRange(
    fs.missing_non_highlighted_features,
    minShare,
    maxShare
  ).map(
    (item): EquipmentFlagItem => ({
      feature: item.feature,
      category: 'missingFeature',
    })
  );

  return [...highlighted, ...nonHighlighted, ...missingHighlighted, ...missingNonHighlighted];
}
